﻿export function initRevealOnScroll() {
    const items = Array.from(document.querySelectorAll(".reveal-on-scroll"));
    if (!items.length) return;

    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
        }
    }, {
        threshold: 0.14,
        rootMargin: "0px 0px -40px 0px"
    });

    items.forEach(item => observer.observe(item));
}